import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'

export const MENU_NAME = 'menu'

@Module({ namespaced: true, name: MENU_NAME })
export default class MenuModule extends VuexModule {





  @Mutation
  activeMenuId(id: number) {
  }

  @Mutation
  togglePanelShow(isShow?: boolean) {

  }
}
